import React from "react";
// import {ProgressBar} from "react-bootstrap";
// import "./style.css"
/**
 * @author
 * @function Intro
 **/

const Skills = (props) => {
  return (
    <section id="skills" className="skills section-bg">
      <div className="container" data-aos="fade-up">
        <div className="section-title">
          <h2>Skills</h2>
          <p>Below is a quick overview of my technical skill sets and tools I use</p>
        </div>
        <div className="row skills-content">
          <div className="col-lg-6">
            <h6>Back End</h6>
            <div className="progress">
              <span className="skill"> Node.js <i className="val">80%</i></span>
              <div className="progress-bar-wrap">
                {/* <ProgressBar now={80}/> */}
                <div className="progress-bar" role="progressbar" aria-valuenow={80} aria-valuemin={0} aria-valuemax={100} style={{ width: "80%" }} />
              </div>
            </div>
            <div className="progress">
              <span className="skill"> Express JS <i className="val">80%</i></span>
              {/* <ProgressBar now={80}/> */}
              <div className="progress-bar-wrap">
                <div className="progress-bar" role="progressbar" aria-valuenow={80} aria-valuemin={0} aria-valuemax={100} style={{ width: "80%" }} />
              </div>
            </div>
            <div className="progress">
              <span className="skill"> Javascript<i className="val">90%</i></span>
              <div className="progress-bar-wrap">
                <div className="progress-bar" role="progressbar" aria-valuenow={90} aria-valuemin={0} aria-valuemax={100} style={{ width: "90%" }} />
              </div>
            </div>
            <div className="progress">
              <span className="skill">Mongoose <i className="val">75%</i></span>
              <div className="progress-bar-wrap">
                <div className="progress-bar" role="progressbar" aria-valuenow={75} aria-valuemin={0} aria-valuemax={100} style={{ width: "75%" }} />
              </div>
            </div>
            <div className="progress">
              <span className="skill"> Django <i className="val">75%</i></span>
              <div className="progress-bar-wrap">
                <div className="progress-bar" role="progressbar" aria-valuenow={75} aria-valuemin={0} aria-valuemax={100} style={{ width: "75%" }} />
              </div>
            </div>
            <div className="progress">
              <span className="skill">Flask <i className="val">75%</i></span>
              <div className="progress-bar-wrap">
                <div className="progress-bar" role="progressbar" aria-valuenow={75} aria-valuemin={0} aria-valuemax={100} style={{ width: "75%" }} />
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <h6>Front End</h6>
            <div className="progress">
              <span className="skill"> React/Redux <i className="val">70%</i></span>
              <div className="progress-bar-wrap">
                <div className="progress-bar" role="progressbar" aria-valuenow={70} aria-valuemin={0} aria-valuemax={100} style={{ width: "70%" }} />
              </div>
            </div>
            <div className="progress">
              <span className="skill"> HTML5 <i className="val">80%</i></span>
              <div className="progress-bar-wrap">
                <div className="progress-bar" role="progressbar" aria-valuenow={80} aria-valuemin={0} aria-valuemax={100} style={{ width: "80%" }} />
              </div>
            </div>
            <div className="progress">
              <span className="skill"> CSS3 <i className="val">70%</i></span>
              <div className="progress-bar-wrap">
                <div className="progress-bar" role="progressbar" aria-valuenow={90} aria-valuemin={0} aria-valuemax={100} style={{ width: "70%" }} />
              </div>
            </div>
            <div className="progress">
              <span className="skill"> Bootstrap <i className="val">65%</i></span>
              <div className="progress-bar-wrap">
                <div className="progress-bar" role="progressbar" aria-valuenow={65} aria-valuemin={0} aria-valuemax={100} style={{ width: "65%" }} />
              </div>
            </div>
            <div className="progress">
              <span className="skill"> Angular <i className="val">55%</i></span>
              <div className="progress-bar-wrap">
                <div className="progress-bar" role="progressbar" aria-valuenow={55} aria-valuemin={0} aria-valuemax={100} style={{ width: "55%" }} />
              </div>
            </div>
            <div className="progress">
              <span className="skill"> JQuery <i className="val">65%</i></span>
              <div className="progress-bar-wrap">
                <div className="progress-bar" role="progressbar" aria-valuenow={65} aria-valuemin={0} aria-valuemax={100} style={{ width: "65%" }} />
              </div>
            </div>
          </div>
        </div>
        <div className="row skills-content">
          <div className="col-lg-6">
            <h6>DATABASE</h6>
            <div className="progress">
              <span className="skill"> IBM DB2 <i className="val">80%</i></span>
              <div className="progress-bar-wrap">
                <div className="progress-bar" role="progressbar" aria-valuenow={80} aria-valuemin={0} aria-valuemax={100} style={{ width: "80%" }} />
              </div>
            </div>
            <div className="progress">
              <span className="skill"> MySQL <i className="val">80%</i></span>
              <div className="progress-bar-wrap">
                <div className="progress-bar" role="progressbar" aria-valuenow={80} aria-valuemin={0} aria-valuemax={100} style={{ width: "80%" }} />
              </div>
            </div>
            <div className="progress">
              <span className="skill"> PostgreSQL <i className="val">65%</i></span>
              <div className="progress-bar-wrap">
                <div className="progress-bar" role="progressbar" aria-valuenow={65} aria-valuemin={0} aria-valuemax={100} style={{ width: "65%" }} />
              </div>
            </div>
            <div className="progress">
              <span className="skill"> MongoDB <i className="val">80%</i></span>
              <div className="progress-bar-wrap">

                <div className="progress-bar" role="progressbar" aria-valuenow={80} aria-valuemin={0} aria-valuemax={100} style={{ width: "80%" }} />
              </div>
            </div>
            <h6>Language</h6>
            <div className="progress">
              <span className="skill"> Javascript <i className="val">85%</i></span>
              <div className="progress-bar-wrap">
                <div className="progress-bar" role="progressbar" aria-valuenow={85} aria-valuemin={0} aria-valuemax={100} style={{ width: "85%" }} />
              </div>
            </div>
            <div className="progress">
              <span className="skill"> Python <i className="val">75%</i></span>
              <div className="progress-bar-wrap">
                <div className="progress-bar" role="progressbar" aria-valuenow={75} aria-valuemin={0} aria-valuemax={100} style={{ width: "75%" }} />
              </div>
            </div>
            <div className="progress">
              <span className="skill"> COBOL <i className="val">65%</i></span>
              <div className="progress-bar-wrap">
                <div className="progress-bar" role="progressbar" aria-valuenow={65} aria-valuemin={0} aria-valuemax={100} style={{ width: "65%" }} />
              </div>
            </div>
            <div className="progress">
              <span className="skill"> JCL <i className="val">65%</i></span>
              <div className="progress-bar-wrap">
                <div className="progress-bar" role="progressbar" aria-valuenow={65} aria-valuemin={0} aria-valuemax={100} style={{ width: "65%" }} />
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <h6>TOOLS AND TECHNOLOGIES</h6>
            <div className="progress">
              <span className="skill"> Git Version Control <i className="val">80%</i></span>
              <div className="progress-bar-wrap">
                <div className="progress-bar" role="progressbar" aria-valuenow={80} aria-valuemin={0} aria-valuemax={100} style={{ width: "80%" }} />
              </div>
            </div>
            <div className="progress">
              <span className="skill"> JIRA <i className="val">80%</i></span>
              <div className="progress-bar-wrap">
                <div className="progress-bar" role="progressbar" aria-valuenow={80} aria-valuemin={0} aria-valuemax={100} style={{ width: "80%" }} />
              </div>
            </div>
            <div className="progress">
              <span className="skill"> JENKINS <i className="val">70%</i></span>
              <div className="progress-bar-wrap">
                <div className="progress-bar" role="progressbar" aria-valuenow={70} aria-valuemin={0} aria-valuemax={100} style={{ width: "70%" }} />
              </div>
            </div>
            <div className="progress">
              <span className="skill"> DEVOPS TOOLS <i className="val">70%</i></span>
              <div className="progress-bar-wrap">
                <div className="progress-bar" role="progressbar" aria-valuenow={70} aria-valuemin={0} aria-valuemax={100} style={{ width: "70%" }} />
              </div>
            </div>
            <div className="progress">
              <span className="skill"> CI/CD <i className="val">70%</i></span>
              <div className="progress-bar-wrap">
                <div className="progress-bar" role="progressbar" aria-valuenow={70} aria-valuemin={0} aria-valuemax={100} style={{ width: "70%" }} />
              </div>
            </div>
            <div className="progress">
              <span className="skill"> AGILE <i className="val">60%</i></span>
              <div className="progress-bar-wrap">
                <div className="progress-bar" role="progressbar" aria-valuenow={60} aria-valuemin={0} aria-valuemax={100} style={{ width: "60%" }} />
              </div>
            </div>
            <div className="progress">
              <span className="skill"> ALM <i className="val">60%</i></span>
              <div className="progress-bar-wrap">
                <div className="progress-bar" role="progressbar" aria-valuenow={60} aria-valuemin={0} aria-valuemax={100} style={{ width: "60%" }} />
              </div>
            </div>
            <div className="progress">
              <span className="skill"> Changeman <i className="val">70%</i></span>
              <div className="progress-bar-wrap">
                <div className="progress-bar" role="progressbar" aria-valuenow={70} aria-valuemin={0} aria-valuemax={100} style={{ width: "70%" }} />
              </div>
            </div>
            <div className="progress">
              <span className="skill"> Docker <i className="val">60%</i></span>
              <div className="progress-bar-wrap">
                <div className="progress-bar" role="progressbar" aria-valuenow={60} aria-valuemin={0} aria-valuemax={100} style={{ width: "60%" }} />
              </div>
            </div>
          </div>
        </div>
        <div className="row skills-content">
          <div className="col-lg-6">
            <h6>CAD &amp; CAM</h6>
            <div className="progress">
              <span className="skill"> SolidWorks <i className="val">80%</i></span>
              <div className="progress-bar-wrap">
                <div className="progress-bar" role="progressbar" aria-valuenow={80} aria-valuemin={0} aria-valuemax={100} style={{ width: "80%" }} />
              </div>
            </div>
            <div className="progress">
              <span className="skill"> PTC Creo/Pro-e <i className="val">70%</i></span>
              <div className="progress-bar-wrap">
                <div className="progress-bar" role="progressbar" aria-valuenow={70} aria-valuemin={0} aria-valuemax={100} style={{ width: "70%" }} />
              </div>
            </div>
            <div className="progress">
              <span className="skill"> Autodesk Inventor <i className="val">60%</i></span>
              <div className="progress-bar-wrap">
                <div className="progress-bar" role="progressbar" aria-valuenow={60} aria-valuemin={0} aria-valuemax={100} style={{ width: "60%" }} />
              </div>
            </div>
            <div className="progress">
              <span className="skill"> 2D CAD : Autocad / DraftSight <i className="val">80%</i></span>
              <div className="progress-bar-wrap">
                <div className="progress-bar" role="progressbar" aria-valuenow={80} aria-valuemin={0} aria-valuemax={100} style={{ width: "80%" }} />
              </div>
            </div>
            <div className="progress">
              <span className="skill"> CAM : Autodesk PowerMill / MasterCAM<i className="val">60%</i></span>
              <div className="progress-bar-wrap">
                <div className="progress-bar" role="progressbar" aria-valuenow={60} aria-valuemin={0} aria-valuemax={100} style={{ width: "60%" }} />
              </div>
            </div>
          </div>
          <div className="col-lg-6">
            <h6>CAE</h6>
            <div className="progress">
              <span className="skill"> Ansys APDL <i className="val">70%</i></span>
              <div className="progress-bar-wrap">
                <div className="progress-bar" role="progressbar" aria-valuenow={70} aria-valuemin={0} aria-valuemax={100} style={{ width: "70%" }} />
              </div>
            </div>
            <div className="progress">
              <span className="skill"> Ansys Workbench (Static Structural) <i className="val">70%</i></span>
              <div className="progress-bar-wrap">
                <div className="progress-bar" role="progressbar" aria-valuenow={70} aria-valuemin={0} aria-valuemax={100} style={{ width: "70%" }} />
              </div>
            </div>
            <div className="progress">
              <span className="skill"> Ansys (fluent &amp; cfx) <i className="val">60%</i></span>
              <div className="progress-bar-wrap">
                <div className="progress-bar" role="progressbar" aria-valuenow={60} aria-valuemin={0} aria-valuemax={100} style={{ width: "60%" }} />
              </div>
            </div>
            <div className="progress">
              <span className="skill"> Hyperworks (Hypermesh Part) <i className="val">70%</i></span>
              <div className="progress-bar-wrap">
                <div className="progress-bar" role="progressbar" aria-valuenow={70} aria-valuemin={0} aria-valuemax={100} style={{ width: "70%" }} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default Skills;